var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionCircle = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm16.5 0a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0Zm-6.75 4.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.34-8.49c-.862-1.396-3.121-1.608-5.003-.776a.75.75 0 0 0 .606 1.372c1.279-.565 2.738-.428 3.122.192.409.662.15 1.505-.77 2.284-1.329 1.127-1.795 1.786-1.795 2.793a.75.75 0 0 0 1.5 0c0-.312.125-.579.569-1.02l.194-.187c.071-.065.148-.135.232-.208l.41-.356c1.323-1.198 1.76-2.76.936-4.095Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionCircle);
export default ForwardRef;